export const productsDictionary = {
    Cotizaciones: {
        es: "Cotizaciones",
        en: "Market Prices",
    },
    Mercados: {
        es: "Mercados",
        en: "Markets",
    },
};
